import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/calculo-fuente-financiamiento';

/**
 * GET fuentes por nómina
 */
export const getCalculoFuentesFinanciamiento = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET fuente financiamiento
 */
export const getCalculoFuenteFinanciamiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 */
export const postCalculoFuenteFinanciamiento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH
 */
export const patchCalculoFuenteFinanciamiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE
 */
export const deleteCalculoFuenteFinanciamiento = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    onSuccess({}, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST reparto de una Percepción entre varias Fuentes de Financiamiento registradas.
 * payload: { nomina, percepcion, tipo_empleado_presupuestal,
 *            repartos: [{ parametro_diverso_id, importe }, ...] }
 */
export const repartirCalculoFuenteFinanciamiento = async (payload) => {
  try {
    const response = await API.post(`${baseURI}/repartir`, payload);
    onSuccess(response, 'Reparto guardado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
